import { FeatureToggle, isFeatureEnabled } from '../../util/featureToggle';
import GTM from '../../gtm/GTM';
import GTMViewItemModel from '../../gtm/models/GTMViewItemModel';
import DetailFormTracking from './components/DetailFormTracking';

document.addEventListener('DOMContentLoaded', (): void => {
    if (!isFeatureEnabled(FeatureToggle.GOOGLE_TAG_MANAGER)) {
        return;
    }

    const houseData = DetailFormTracking.getHouseDetailDataLayerData();
    const house = houseData?.products?.[0];

    if (!houseData || !house) {
        return;
    }

    GTM.track(
        GTMViewItemModel.parseToGTMData({
            isDateSelected: false,
            value: 0,
            id: houseData.products[0].id,
            title: houseData.products[0].name,
            country: houseData.custom_lastcountry,
            region: houseData.custom_lastregion,
            department: houseData.custom_lastdepartment,
            place: houseData.custom_lastcity,
            discount: 0,
            pricePerNight: 0,
            instantBooking: false,
            quantity: 1
        })
    );
});
